import VeeValidate from 'vee-validate';
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import validationMessages from 'vee-validate/dist/locale/en';

Vue.use(VueI18n);

const i18n = new VueI18n();
i18n.locale = 'en'; // set a default locale (without it, it won't work).

VeeValidate.Validator.extend('verifyPassword', {
    validate: (value) => {
        var strongRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])');
        return strongRegex.test(value);
    },
});

Vue.use(VeeValidate, {
    i18nRootKey: 'validations', // customize the root path for validation messages.
    i18n,
    dictionary: {
        en: {
            messages: {
                ...validationMessages.messages,
                verifyPassword:
                    'This field must contain at least: 1 uppercase letter, 1 lowercase letter',
            },
        },
    },
    events: 'blur',
});
